
import { AuthPayload } from '@/interfaces/ui.interface'
import api from '@/plugins/axios'

export default {
  async fetchGallery({ commit }: any, search: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.get('/gallery', {
        params: search.params
      })
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion de la galería obtenida con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
      // commit('setGallery', response.data)
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al consultar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setGallery', payload)
    }
  },
  async postGallery({ commit }: any, formData: FormData) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.post('/addGaleria', formData)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion almacenada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al guardar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('addGalleryItem', payload)
    }
  },
  async putGallery({ commit }: any, { id, formData }: { id: number, formData: FormData }) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.post(`/updateGallery/${id}`, formData)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion actualizada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al editar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('editGalleryItem', payload)
    }
  },
  async delGallery({ commit }: any, id: number) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
      try {
        const response = await api.delete(`/deleteGallery/${id}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion eliminada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('delGalleryItem', payload)
    }
  }
}
